import React, { useState } from 'react';
import { Box, TextField, Button, CircularProgress } from '@mui/material';
import { YouTube as YouTubeIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';

interface VideoFormProps {
  onSubmit: (url: string) => void;
  loading: boolean;
}

const VideoForm = ({ onSubmit, loading }: VideoFormProps) => {
  const [url, setUrl] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (url.trim()) {
      onSubmit(url.trim());
    }
  };

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          maxWidth: '800px',
          mx: 'auto',
          p: 3,
          borderRadius: 2,
          bgcolor: 'background.paper',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Paste YouTube URL here..."
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          disabled={loading}
          InputProps={{
            startAdornment: (
              <YouTubeIcon sx={{ mr: 1, color: 'error.main' }} />
            ),
            sx: {
              borderRadius: 2,
              '&.Mui-focused': {
                boxShadow: '0 0 0 2px #00ff9d',
              },
            },
          }}
        />
        <Button
          type="submit"
          variant="contained"
          disabled={loading || !url.trim()}
          sx={{
            minWidth: { xs: '100%', sm: '150px' },
            height: '56px',
            background: 'linear-gradient(45deg, #00ff9d 30%, #ff0099 90%)',
            color: 'background.paper',
            '&:hover': {
              background: 'linear-gradient(45deg, #00ff9d 20%, #ff0099 100%)',
              transform: 'scale(1.02)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Download'
          )}
        </Button>
      </Box>
    </motion.div>
  );
};

export default VideoForm; 